<template>
    <el-dialog
        class="external-resource--import-dialog"
        title="导入"
        :visible.sync="visible"
        :before-close="handleClose">
        <div>
            <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                :on-remove="handleRemove"
                :on-change="onchange"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :show-file-list="true"
                :auto-upload="false"
                :before-upload="getUploadInfo"
                :http-request="addAttachment"
                :accept="'.xlsx'">
                <el-button type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传Excel文件，且不超过{{SRM_FILE_MAX_SIZE}}MB</div>
            </el-upload>
        </div>
        <div>
            <div class="template-tip">
                模板下载
                <el-button type="text" @click="handleExportTemplate">模板.xlsx</el-button>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import request from '@/utils/http'
import { SRM_FILE_PRE, SRM_FILE_MAX_SIZE } from '../../../constant/constant.js'

const THOUSAND_TWENTY_FOUR = 1024

export default {
    name: 'ImportDialog',
    components: {},
    props: {
        exportTemplate: {
            type: Function,
            default() {
                return () => {}
            },
        },
    },
    data() {
        return {
            SRM_FILE_MAX_SIZE,
            visible: false,
            loading: false,
            fileList: [],
        }
    },
    computed: {},
    methods: {
        handleClose() {
            this.fileList = []
            this.visible = false
        },
        handleVisible(flag, data) {
            this.visible = !!flag
        },
        handleConfirm() {
            this.$refs.upload.submit()
        },
        //下载模板
        handleExportTemplate() {
            this.exportTemplate()
                .then(res => {
                    if (res && +res.code === 0) {
                        var a = document.createElement('a');
                        a.href = res.data.downUrl;
                        a.download = res.data.localFileName;
                        a.click();
                        this.$message.success('下载成功');
                    }
                })
                .catch(() => {})
        },
        handleRemove(row) {
            this.fileList.splice(row, 1)
        },
        onchange(file, fileList) {},
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
                    files.length + fileList.length
                } 个文件`,
            )
        },
        getUploadInfo(file) {
            // 不允许上传不可预览格式文件
            let uploadTypeReg = /\.(xls|xlsx)$/
            let fileType = file.name.slice(file.name.lastIndexOf('.'))

            if (!uploadTypeReg.test(fileType.toLowerCase())) {
                this.$message.warning('不支持上传' + fileType + '格式文件')
                return false
            }
            if (file.size >= SRM_FILE_MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                this.$message.warning('上传文件不能大于' + SRM_FILE_MAX_SIZE + 'MB')
                return false
            }
        },
        addAttachment(file) {

            this.loading = true
            const param = new FormData()
            param.append('file', file.file)
            return request({
                url: `${SRM_FILE_PRE}/supplierWarehouseWorkerSalaryConfirm/importSalaryConfirmReason`,
                method: 'post',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: param,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data)
                        this.$emit('reload')
                        this.handleClose()
                    } else {
                        // this.$emit('import-callback', false);
                    }
                    this.loading = false
                })
                .catch(res => {
                    this.loading = false
                })
        },
    },
    mounted() {},
}
</script>
<style lang="less">
.external-resource--import-dialog {
    .upload-demo {
        position: relative;

        .el-upload {
            margin-bottom: 20px;
        }

        .el-upload__tip {
            position: absolute;
            top: 0;
            left: 100px;
            font-size: 12px;
        }
    }

    .template-tip {
        padding-left: 43px;
    }

    .template-tip,
    .el-button {
        font-size: 14px;
    }
}
</style>
